import { PositionDto } from '@dto/position.dto';

export class WorkspaceItemContentDto {
  public id: number;                  // Used to set Box id
  public symbol: string;
  public company: string;
  public type: string;                // Constants.WINDOW_NAME...
  public position: PositionDto;
  public showInGridster: boolean;
  public workspaceId: number;
  public selected_worksheet: number;
  public title: string;
  public worksheetTitle: string;
  public columns?: any;
  public filter?: any;

  constructor(id: number, symbol: string, company: string, type: string, position: PositionDto,
    showInGridster: boolean, workspaceId: number, filter?: any, title?: string, worksheetTitle?: string, columns?: any,
    selected_worksheet?: number
  ) {
    this.id = id;
    this.symbol = symbol;
    this.company = company;
    this.type = type;
    if (selected_worksheet) {
      this.selected_worksheet = selected_worksheet;
    }
    this.workspaceId = workspaceId;
    this.position = position;
    this.showInGridster = showInGridster;
    if (title) {
      this.title = title;
    }
    if (worksheetTitle) {
      this.worksheetTitle = worksheetTitle;
    }
    if (columns) {
      this.columns = columns;
    }
    if (filter !== null && filter !== undefined) {
      this.filter = filter;
    }
  }
}
